import { CarsShopActions } from "@b2bportal/core-cars";
import {
  BundleResponseEnum,
  PackageEndpointsV2,
  type PackagesCustomizeCarsShopRequest,
  type PackagesCustomizeCarsShopResponse,
} from "@b2bportal/core-packages";
import { axiosInstance } from "@hopper-b2b/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { PackagesBaseActions } from "@/store/packages/slice/packages";

export const fetchPackageCarsShop = createAsyncThunk<
  void,
  {
    packageToken: string;
    opaqueShopRequestContext: string;
    opaqueShopRequestVehicle: string;
  }
>(
  "packages/fetchCarsShop",
  async (
    { packageToken, opaqueShopRequestContext, opaqueShopRequestVehicle },
    thunkAPI
  ) => {
    try {
      const request: PackagesCustomizeCarsShopRequest = {
        customize: {
          bundledPackageStateToken: { value: packageToken },
          carShopRequest: {
            opaqueShopRequestContext,
            opaqueShopRequestVehicle,
          },
        },
      };

      const { data }: { data: PackagesCustomizeCarsShopResponse } =
        await axiosInstance.post(PackageEndpointsV2.Customize, request);

      if (data.BundleResponse === BundleResponseEnum.CarShopResponse) {
        // Update the main package token
        thunkAPI.dispatch(
          PackagesBaseActions.setCurrentActivePackage(
            data.carShop.bundledPackageState
          )
        );
        // pass along the shop response to cars
        thunkAPI.dispatch(
          CarsShopActions.setShopResponseFromPackages(data.carShop.shopResponse)
        );
        return;
      } else {
        throw new Error("Invalid package car shop response", {
          cause: data.BundleResponse,
        });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({
        error:
          error instanceof Error ? error.message : "Unknown error occurred",
        details: error,
      });
    }
  }
);
